import { AttributesActionTypes, AttributesActionUnion } from './attributes.actions';
import { adapter, AttributesState, initialState, selectAttributesIdFrom } from './attributes.state';

export function attributesReducer(
  state: AttributesState = initialState,
  action: AttributesActionUnion
): AttributesState {
  switch (action.type) {
    case AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_LOADED:
    case AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_UPDATED:
      return adapter.upsertOne(action.payload.attributes, state);
    case AttributesActionTypes.ATTRIBUTES_SIGNALR_STATE_CHANGED: {
      const values = {
        reservationId: String(action.payload.changes.ReservationId),
        attributes: action.payload.changes.Attributes ?? [],
      };
      return adapter.upsertOne(values, state);
    }
    case AttributesActionTypes.ATTRIBUTES_API_ATTRIBUTES_DELETED:
      return adapter.removeOne(selectAttributesIdFrom(action.payload.attributes), state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAttributesIds = selectIds;

export const selectAttributesEntities = selectEntities;

export const selectAllAttributes = selectAll;
